<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <IconWrapper :size="size" v-html="svgContent" />
</template>

<script setup lang="ts">
  import flags from "virtual:flags";

  defineOptions({
    name: "Flag",
  });

  const props = withDefaults(
    defineProps<{
      countryCode: string;
      size?: "sm" | "md" | "lg" | "xl";
    }>(),
    {
      size: "md",
    }
  );

  const svgContent = computed(() => flags[props.countryCode?.toLowerCase?.() ?? ""] ?? "");
</script>
